import '../styles/projects.scss';
import { FaCode } from 'react-icons/fa';

const projectData = [
  {id: 1, title: 'NLW Together Rocketseat', image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/5c791c242349753.Y3JvcCw5MDAsNzA0LDM0OSww.png', 
   code: 'https://github.com/maikelensalles/Letmeask-ReactJS', tags: ['React.js', 'TypeScript', 'SASS', 'HTML']},
  {id: 2, title: 'Projetos Web Design', image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/76e0a4227295719.Y3JvcCwxMDIyLDgwMCwxMjksMA.png', 
   code: 'https://www.behance.net/maikelensalles-tech/projects', tags: ['HTML', 'CSS', 'JavaScript', 'WordPress']},
  {id: 3, title: 'UX Design', image: 'https://mir-s3-cdn-cf.behance.net/projects/max_808/1cb35a228627475.Y3JvcCwxOTYzLDE1MzYsNTg4LDA.png', 
   code: 'https://www.figma.com/file/aGJd7qpweEGxdR3awxSbNh/Squash?node-id=0%3A1', tags: ['Figma', 'UI/UX', 'Material Design']},
  {id: 5, title: 'Sistema para gerenciamento de aplicativo P2P', image: '	https://mir-s3-cdn-cf.behance.net/project_modules/fs/ef1ddd242349753.696b1b074ace9.png', 
   code: 'https://github.com/maikelensalles/forte-play', tags: ['JavaScript', 'CSS', 'SASS', 'Laravel']},
  {id: 6, title: 'Sistema para gerenciamento de delivery', image: '	https://mir-s3-cdn-cf.behance.net/project_modules/fs/190a04242349753.696b1b074c18c.png',
   code: 'https://github.com/maikelensalles/delivery', tags: ['Laravel', 'Blade', 'Less']},
  {id: 7, title: 'Sistema para gerenciamento de investimentos', image: '	https://mir-s3-cdn-cf.behance.net/project_modules/fs/f68ac4242349753.696b1b074b60d.png',
   code: 'https://github.com/maikelensalles/ativos-master', tags: ['Blade', 'PHP', 'Laravel']}
];

export function Projects() {
    return (
      <div id="projects">
        <div className="projects-header">
          <h2>Projetos</h2>
        </div>
        <div className="projects--body">
          <div className="projects--bodyContainer">
            {projectData.slice(0, 9).map(project => (
              <div className="singleProject" key={project.id}>
                <div className="projectContent">
                  <h2>{project.title}</h2>
                  <img src={project.image} alt=''/>
                  <div className='project--showcaseBtn'>
                      <a
                          href={project.code}
                          target='_blank'
                          rel='noreferrer'
                      >
                          <FaCode
                            className='icon'
                          />
                      </a>
                  </div>
                </div>
                <div className='project--lang'>
                {project.tags.map((tag, id) => (
                        <span key={id}>{tag}</span>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>    
    )
}